import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';
import styled, { css } from 'styled-components';

import { sanitizeHTML } from '../../utilities';

const Copyright = ({
  className,
  floating,
  htmlContent,
  textFontFamily,
  textColor,
  enabledOverlapMenu,
  ...props
}) => {
  const { t } = useTranslation();

  return (
    <Root
      {...props}
      className={className}
      floating={floating}
      textFontFamily={textFontFamily}
      textColor={textColor}
    >
      {!enabledOverlapMenu && <Info textColor={textColor}>{t('copyrightText')}</Info>}
      <Content
        textColor={textColor}
        dangerouslySetInnerHTML={{ __html: sanitizeHTML(htmlContent) }}
      />
    </Root>
  );
};

Copyright.propTypes = {
  className: PropTypes.string,
  floating: PropTypes.bool,
  textFontFamily: PropTypes.string,
  textColor: PropTypes.string,
  htmlContent: PropTypes.string,
  enabledOverlapMenu: PropTypes.bool
};

Copyright.defaultProps = {
  floating: false,
  htmlContent: '',
  textFontFamily: '"Lato", sans-serif',
  textColor: '#fff',
  enabledOverlapMenu: false
};

const Root = styled.div`
  font-family: ${props => props.textFontFamily};
  font-size: 10px;
  font-weight: 400;
  line-height: 12px;
  color: ${props => props.textColor};

  span {
    width: auto;
    font: inherit;
    color: inherit;
  }
  span + span {
    margin-left: 3px;
  }

  a {
    font: inherit;
    color: ${props => props.textColor} !important;
    text-decoration-line: underline;
    text-decoration-color: transparent;
    transition: all 0.2s;
    &:hover,
    &:focus {
      color: ${props => props.textColor} !important;
      text-decoration: underline;
    }
  }

  ${({ floating }) =>
    floating &&
    css`
      position: absolute;
      right: 0;
      bottom: -8px;
      padding-right: 4px;
      text-align: right;
      text-shadow: 0 1px 1px rgba(0, 0, 0, 0.2);
      background-color: transparent;
      transform: translateY(100%);
    `}
`;

const Info = styled.span`
  color: ${props => props.textColor};
`;

const Content = styled.span`
  color: ${props => props.textColor};

  a::before,
  a::after {
    content: '';
    display: none;
  }
`;

export default Copyright;
